import { apiFetch } from '../../lib/api';
import type { ExplorerQueryState } from './explorerQueryState';

export interface PkgBookmark {
  id: string;
  name: string;
  queryParams: ExplorerQueryState;
  createdAt: string;
}

export function listPkgBookmarks(projectId: string): Promise<PkgBookmark[]> {
  return apiFetch<PkgBookmark[]>(`/projects/${projectId}/pkg/bookmarks`);
}

// Save-current-view: persists `queryState` verbatim (V2) — no separate
// translation step between what's displayed and what's saved.
export function createPkgBookmark(
  projectId: string,
  name: string,
  queryParams: ExplorerQueryState,
): Promise<PkgBookmark> {
  return apiFetch<PkgBookmark>(`/projects/${projectId}/pkg/bookmarks`, {
    method: 'POST',
    body: JSON.stringify({ name, queryParams }),
  });
}

export function deletePkgBookmark(projectId: string, bookmarkId: string): Promise<void> {
  return apiFetch<void>(`/projects/${projectId}/pkg/bookmarks/${bookmarkId}`, {
    method: 'DELETE',
  });
}
